<ion-header>
  <ion-row class="ion-align-items-center ion-padding-horizontal">
    <ion-col class="">
      <h1 style="margin: 0">{{ 'cutbank_common.TAG_HISTORY' | translate }}</h1>
    </ion-col>
    <ion-col size="auto">
      <ion-row class="ion-align-items-center">
        <ion-col>
          <ion-searchbar
            [placeholder]="'cutbank_landing.enterTagId' | translate"
            [(ngModel)]="tagId"
            class="tag-id-search"
          >
          </ion-searchbar>
        </ion-col>
        <ion-col size="auto">
          <ui-custom-button
            [btnTxt]="'cutbank_logs.search' | translate"
            [buttonType]="'SECONDARY'"
            (clickEvent)="searchTagId()"
          >
          </ui-custom-button>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-header>
<ion-content class="ion-padding">
  <ng-container *ngIf="data.length > 0; else noDataMessage">
    <ion-row class="bctx-row">
      <ion-col *ngFor="let item of conf['summary_props']; let i = index">
        <ion-row class="summary-label">{{ conf['summary_names'][i] }}</ion-row>
        <div class="summary-value">{{ details[item] }}</div>
      </ion-col>
    </ion-row>
    <ion-grid class="time-line-wrap">
      <ion-row class="history-log-row" *ngFor="let msg of data">
        <ion-col col-2 class="time-date-col">
          <div>{{ msg.date }}</div>
          <div>{{ msg.time }}</div>
        </ion-col>
        <ion-col class="border-l" size="6">
          <div class="msg-1">{{ msg?.dn || msg?.domRole_dn }}</div>
          <div class="subject">{{ msg?.subject }}</div>
        </ion-col>
        <ion-col col-2 class="border-l center">
          <div [ngClass]="{ 'bdg-del': msg.status === 'deleted', 'bdg-add': msg.status != 'deleted' }">
            {{ msg?.status }}
          </div>
        </ion-col>
        <ion-col col-2 class="border-l center">
          <div class="msg-1">{{ msg?.line || msg?.module_id }}</div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-template #noDataMessage>
    <div class="no-data-message">{{ 'cutbank_logs.noRecordsToPreview' | translate }}</div>
  </ng-template>
</ion-content>
<ion-footer style="background-color: rgb(240, 240, 240)" class="ion-padding">
  <ion-row class="ion-float-right">
    <ui-custom-button
      [btnTxt]="'common.CLOSE' | translate"
      [buttonType]="'SECONDARY'"
      [fontWeight]="'BOLD'"
      (clickEvent)="closeModal()"
    ></ui-custom-button>
  </ion-row>
</ion-footer>
